import { ConstructorID } from "../types";

export const positions = [
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "11th",
  "12th",
  "13th",
  "14th",
  "15th",
  "16th",
  "17th",
  "18th",
  "19th",
  "20th",
];

export const darkTextColorTeams = [
  ConstructorID.Haas,
  ConstructorID.RacingPoint,
  ConstructorID.Renault,
  ConstructorID.LotusF1,
  ConstructorID.Hrt,
];
